<ms-competition-tree [sport]="sport" [context]="context" [tournaments]="tournaments"></ms-competition-tree>
